GridEventEmitter = function () {};
heir.inherit(GridEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
GridEventEmitter.prototype.addListener = function (name, action, listener) {
    AppEventEmitter.prototype.addListener.call(this, (name + '.' + action), listener);
};
// noinspection JSCheckFunctionSignatures
GridEventEmitter.prototype.emitEvent = function (name, action, args) {
    name = typeof name === 'object' ? $(name).data('name') : name;
    args = args || {};
    $.extend(args, { e: $('#grid_' + name.replace(/\./g, '_')), name: name });
    AppEventEmitter.prototype.emitEvent.call(this, ('*' + '.' + action), [ args ]);
    AppEventEmitter.prototype.emitEvent.call(this, (name + '.' + action), [ args ]);
};

app.grid = new GridEventEmitter();
app.grid.INIT = 'init';
app.grid.UPDATE = 'update';
app.grid.BEFORE_AJAX_UPDATE = 'before_ajax_update';
app.grid.AFTER_AJAX_UPDATE = 'after_ajax_update';
app.grid.BLOCK_UI = 'block_ui';
app.grid.UNBLOCK_UI = 'unblock_ui';

app.grid.on('*', app.grid.INIT, function (grid) {
    if (grid.e.data('grid')) {
        return;
    } else {
        grid.e.data('grid', true);
    }
    app.btn.trigger(grid.e.data('widget'), app.btn.PG_PREV_UPDATE);
    app.btn.trigger(grid.e.data('widget'), app.btn.PG_NEXT_UPDATE);
    grid.e.yiiGridView({
        ajaxUpdate: [ grid.e.attr('id') ],
        enableHistory: typeof grid.e.data('enable-history') !== 'undefined'
            ? !!grid.e.data('enable-history')
            : true,
        beforeAjaxUpdate: function (id, options) {
            app.grid.trigger(grid.name, app.grid.BEFORE_AJAX_UPDATE, {
                options: options
            });
        },
        afterAjaxUpdate: function () {
            app.grid.trigger(grid.name, app.grid.AFTER_AJAX_UPDATE);
        }
    });
});
{
    app.grid.on('*', app.grid.BEFORE_AJAX_UPDATE, function (grid) {
        app.grid.trigger(grid.name, app.grid.BLOCK_UI);
        grid.e.find('[data-bs-toggle="popover"]').each(function () {
            var instance = bootstrap.Popover.getInstance($(this)[0]);
            if (instance) {
                instance.dispose();
            }
        });
        grid.e.find('[data-bs-toggle="tooltip"]').each(function () {
            var instance = bootstrap.Tooltip.getInstance($(this)[0]);
            if (instance) {
                instance.dispose();
            }
        });
        var $search = $('#search_' + grid.name.replace('.', '_'));
        if ($search.length) {
            grid.options['data'] = $search.serialize();
        }
        var $outer = $(grid.e).find('.table-outer');
        if ($outer.length) {
            if ($outer[0].scrollWidth > $outer[0].clientWidth) {
                $(grid.e).next().attr('data-scroll-left', $outer[0].scrollLeft);
            }
        }
    });
    app.grid.on('*', app.grid.AFTER_AJAX_UPDATE, function (grid) {
        app.btn.trigger(grid.e.data('widget'), app.btn.PG_PREV_UPDATE);
        app.btn.trigger(grid.e.data('widget'), app.btn.PG_NEXT_UPDATE);
        app.grid.trigger(grid.name, app.grid.UNBLOCK_UI);
        if ($(grid.e).find('.table-outer').length) {
            $(grid.e).find('.table-outer')[0].scrollLeft = $(grid.e).next().attr('data-scroll-left');
        }
        $(grid.e).next().removeAttr('data-scroll-left');
    });
}

app.grid.on('*', app.grid.UPDATE, function (grid) {
    if (Object.keys(grid.e.yiiGridView.settings).length) {
        if (grid.page) {
            grid.e.find('.keys').attr('title', function (index, value) {
                return value.replace(/page=\d+/, grid.page);
            });
        }
        $.fn.yiiGridView.update(grid.e.attr('id'));
    }
});

app.grid.on('*', app.grid.BLOCK_UI, function (grid) {
    app.plugin.trigger(app.plugin.UI_BLOCK, {
        e: grid.e.closest('.widget')
    });
});

app.grid.on('*', app.grid.UNBLOCK_UI, function (grid) {
    app.plugin.trigger(app.plugin.UI_UNBLOCK, {
        e: grid.e.closest('.widget')
    });
});
